import { Form, Input, Modal, Select } from 'antd';
import styled from 'styled-components';
import { getMyMemberListByName } from '../../api/constlink';
import { DebounceSelect6 } from '../common/DebounceSelect6';

const StyledDiv = styled.div``;

const { Option } = Select;

interface ApprovalLineAddModalProps {
  visible: boolean;
  approvalLines: any[];
  enterpriseId: string;
  onCreate: (value: any) => void;
  onCancel: () => void;
}

function ApprovalLineAddModal({
  visible,
  approvalLines,
  enterpriseId,
  onCreate,
  onCancel,
}: ApprovalLineAddModalProps) {
  const [form] = Form.useForm();

  const checkDuplicateProjectType = (name: string) => {
    if (
      approvalLines.filter((value: any) => value.name === name).length === 0
    ) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('중복된 이름이 존재합니다.'));
  };

  return (
    <StyledDiv>
      <Modal
        open={visible}
        title="결재선 추가"
        okText="확인"
        cancelText="취소"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              let approvers = [];
              let referers = [];
              if (values.referers === undefined) {
                values.referers = [];
              }
              for (let i = 0; i < values.approvers.length; i++) {
                approvers.push({
                  id: values.approvers[i].value,
                  name: values.approvers[i].label,
                });
              }
              for (let i = 0; i < values.referers.length; i++) {
                referers.push({
                  id: values.referers[i].value,
                  name: values.referers[i].label,
                });
              }
              values.approvers = approvers;
              values.referers = referers;

              onCreate(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <Form form={form} layout="vertical" initialValues={{ type: '0' }}>
          <Form.Item
            name="name"
            label="이름"
            rules={[
              {
                required: true,
              },
              {
                validator: (_, value) => checkDuplicateProjectType(value),
              },
            ]}
          >
            <Input type="name" placeholder="예) 청구서 결재" />
          </Form.Item>

          <Form.Item
            name="type"
            label="종류"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select allowClear placeholder="종류를 선택 하세요.">
              <Option value="0">청구서</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="approvers"
            rules={[
              {
                required: true,
              },
            ]}
            label={'결재선'}
          >
            <DebounceSelect6
              showSearch
              mode="multiple"
              enterpriseId={enterpriseId}
              placeholder="결재자를 순서대로 입력 하세요."
              fetchOptions={getMyMemberListByName}
              style={{ width: '100%' }}
            />
          </Form.Item>
          <Form.Item name="referers" label={'참조자'}>
            <DebounceSelect6
              showSearch
              mode="multiple"
              enterpriseId={enterpriseId}
              placeholder="참조자를 모두 입력 하세요."
              fetchOptions={getMyMemberListByName}
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Form>
      </Modal>
    </StyledDiv>
  );
}

export default ApprovalLineAddModal;
